import axios from "axios";
import { APP_SETTINGS } from "../../config";

export function getFolderListApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.FILES.getFolderList, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function addFolderListApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.FILES.addFolderList, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function getRecentFolderListApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.FILES.getRecentFolderList, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function getFavoriteFolderListApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.FILES.getFavoriteFolderList, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function addAndRemoveFromMyFavFolderApi(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.FILES.addAndRemoveFromMyFavFolder,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export function deleteFolderApi(id, token) {
  var url = `${APP_SETTINGS.API_PATH.FILES.deleteFolder}?Id=${id}`;
  return axios.delete(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export function getDeletedFolderListApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.FILES.getDeletedFolderList, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function getFilesListApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.FILES.getFileList, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function addFileListApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.FILES.addFileList, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export function getRecentFileListApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.FILES.getRecentFilesList, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export function deleteFileApi(id, token) {
  var url = `${APP_SETTINGS.API_PATH.FILES.deleteFile}?Id=${id}`;
  return axios.delete(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export function getDeletedFileListApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.FILES.getDeletedFileList, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}
export function getFavoriteFileListApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.FILES.getFavoriteFileList, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function addAndRemoveFromMyFavFileApi(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.FILES.addAndRemoveFromMyFavFile,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
